"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ThreadListLabel", {
  enumerable: true,
  get: function get() {
    return _Label["default"];
  }
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _reactVirtualized = require("react-virtualized");
var _ApproveSender = require("../ApproveSender");
var _Label = _interopRequireDefault(require("./Label"));
var _excluded = ["renderItem", "total", "isLoaded", "loadMore", "getRowHeight", "rowTypes", "removedIndexes", "footer"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var rowHeights = {
  "default": 104,
  chips: 160,
  cards: 294,
  headerBar: 165,
  headerCards: _ApproveSender.APPROVE_SENDER_HEIGHT,
  label: 30
};
var FOOTER_BASE_HEIGHT = 183;
var ThreadList = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var renderItem = _ref.renderItem,
    total = _ref.total,
    isLoaded = _ref.isLoaded,
    loadMore = _ref.loadMore,
    getRowHeight = _ref.getRowHeight,
    rowTypes = _ref.rowTypes,
    _ref$removedIndexes = _ref.removedIndexes,
    removedIndexes = _ref$removedIndexes === void 0 ? [] : _ref$removedIndexes,
    footer = _ref.footer,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var listRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(FOOTER_BASE_HEIGHT),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    footerHeight = _useState2[0],
    setFooterHeight = _useState2[1];
  var _total = total + (total > 0 && footer ? 1 : 0);
  var rowHeight = (0, _react.useCallback)(function (_ref2) {
    var index = _ref2.index;
    if (removedIndexes.includes(index)) return 0;
    if (index >= total) {
      return footerHeight;
    }
    var rowType = (0, _get["default"])(rowTypes, index, 'default');
    return rowHeights[rowType];
  }, [rowTypes, removedIndexes, footerHeight]);
  var overscanIndicesGetter = (0, _react.useCallback)(function (_ref3) {
    var direction = _ref3.direction,
      cellCount = _ref3.cellCount,
      scrollDirection = _ref3.scrollDirection,
      overscanCellsCount = _ref3.overscanCellsCount,
      startIndex = _ref3.startIndex,
      stopIndex = _ref3.stopIndex;
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  }, []);
  var _rowRenderer = (0, _react.useCallback)(function (params, containerHeight) {
    var index = params.index,
      style = params.style;
    if (index >= total) {
      var top = style.top;
      var newHeight = (containerHeight - top + FOOTER_BASE_HEIGHT) / 2;
      if (containerHeight - top > FOOTER_BASE_HEIGHT && newHeight !== footerHeight) {
        setFooterHeight(newHeight);
      }
      return footer;
    }
    return renderItem(params);
  }, [renderItem, footer, footerHeight]);
  (0, _react.useEffect)(function () {
    if (listRef.current) {
      listRef.current.recomputeRowHeights();
    }
  }, [rowHeight]);
  return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.InfiniteLoader, {
    rowCount: _total,
    isRowLoaded: isLoaded,
    loadMoreRows: loadMore
  }, function (_ref4) {
    var onRowsRendered = _ref4.onRowsRendered,
      registerChild = _ref4.registerChild;
    return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.AutoSizer, null, function (_ref5) {
      var height = _ref5.height,
        width = _ref5.width;
      return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.List, (0, _extends2["default"])({}, rest, {
        ref: function ref(node) {
          registerChild(node);
          listRef.current = node;
        },
        className: "thread-list",
        style: {
          outline: 'none'
        },
        rowRenderer: function rowRenderer(params) {
          return _rowRenderer(params, height);
        },
        rowHeight: rowHeight,
        height: height,
        width: width,
        rowCount: _total,
        onRowsRendered: onRowsRendered,
        overscanRowCount: 5,
        overscanIndicesGetter: overscanIndicesGetter
      }));
    });
  });
});
var _default = exports["default"] = ThreadList;
//# sourceMappingURL=index.js.map